/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Code_InvalidInputs */

const fr_totp_code_invalid = /** @type {(inputs: Totp_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code invalide`)
};

/**

* @param {Totp_Code_InvalidInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_code_invalid = /** @type {((inputs?: Totp_Code_InvalidInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Code_InvalidInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_code_invalid(inputs)
});